// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__gweKh","title":"Login_title__BlKeL"};